import React from 'react';
import styles from './Icons.module.scss';

const LSBLogo: React.FC = () => {
    return (
        <div className={styles.LSBLogo}>
            <h1>
                <span>Lineside</span>
                <br />
                <span>Buildings</span>
                <br />
                <span>Locator</span>
            </h1>
        </div>
    );
};

export default LSBLogo;